const columns = [
    {
        field: "id",
        headerName: "Invoice #",
        description: "Serial ID for taxed invoices, DB ID for others",
        maxWidth: 100,
        flex: 1,
        valueGetter: (value, row) => {
            // Show serialId for typeId=1 invoices if available, otherwise show regular id
            if (row.typeId === 1 && row.serialId) {
                return row.serialId;
            }
            return value;
        },
    },
    {
        field: "OtherParty",
        headerName: "Customer",
        minWidth: 250,
        flex: 1,
        valueGetter: (OtherParty) => {
            return `${OtherParty?.name}: ${OtherParty?.phone}`;
        },
    },
    {
        field: "InvoiceItem",
        headerName: "Items Count",
        minWidth: 100,
        flex: 1,
        valueGetter: (InvoiceItem) => {
            // Count unique products (aggregated items)
            if (!InvoiceItem || !Array.isArray(InvoiceItem)) return 0;
            const uniqueItems = new Set();
            InvoiceItem.forEach((item) => {
                const key = item.item?.id ?? item.itemId;
                uniqueItems.add(key);
            });
            return uniqueItems.size;
        },
    },
    {
        field: "priceFinal",
        headerName: "price",
        minWidth: 50,
        flex: 1,
    },
    {
        field: "discountPercentage",
        headerName: "discountPercentage",
        minWidth: 50,
        flex: 1,
    },
    {
        field: "employee",
        headerName: "Employee",
        minWidth: 50,
        flex: 1,
        valueGetter: (employee) => {
            return `${employee?.name}`;
        },
    },
    {
        field: "createdAt",
        headerName: "createdAt",
        minWidth: 50,
        flex: 1,
        valueGetter: (createdAt) => {
            return new Date(createdAt).toLocaleString();
        },
    },
];
const addSaleFormFields = [];

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Get_URI = (method, data = {}) => {
    switch (method) {
        case "GET":
            return `${REACT_APP_BACKEND_URL}/invoices`;
        case "POST":
            return `${REACT_APP_BACKEND_URL}/items/create`;
        case "PATCH":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        case "DELETE":
            return `${REACT_APP_BACKEND_URL}/items/${data.id}`;
        default:
            return "";
    }
};

export { columns, addSaleFormFields, Get_URI };
